import { Button } from '@/components/ui/button';
import { CustomerDTO } from '../../../../hooks/useCustomer';
import { useDeleteCustomer } from '../../../../hooks/useCustomer';

import { Eraser } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { AlertDialogAction } from '@/components/ui/alert-dialog';
import { AlertDialogFooter } from '@/components/ui/alert-dialog';
import LoadingCircle from '@/components/LoadingCircle';

interface DeleteProps {
  customer: CustomerDTO;
  setPage: () => void;
}

const Delete = ({ customer, setPage }: DeleteProps) => {
  const deleteCustomer = useDeleteCustomer();

  const handleDelete = async () => {
    await deleteCustomer.mutateAsync(customer.id);
    setPage();
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          variant="destructive"
          className="bg-red-500 hover:bg-red-600 border-red-600 transition-colors"
        >
          <Eraser className="w-4 h-4" />
          Xóa
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="luxury-dialog">
        <AlertDialogHeader className="luxury-header">
          <AlertDialogTitle className="luxury-title">
            Xác nhận xóa
          </AlertDialogTitle>
        </AlertDialogHeader>
        <div className="space-y-6">
          <div className="luxury-card">
            <p className="text-center text-lg">
              Bạn có chắc chắn muốn xóa khách hàng{' '}
              <span className="font-semibold text-luxury-900">
                {customer.fullName}
              </span>
              ?
            </p>
            <p className="text-center text-sm text-luxury-700 mt-2">
              Hành động này không thể hoàn tác.
            </p>
          </div>
        </div>
        <AlertDialogFooter className="mt-6 space-x-4">
          <AlertDialogCancel className="w-[120px] luxury-button-outline">
            Hủy
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleDelete}
            className="w-[120px] bg-red-500 hover:bg-red-600 text-white transition-colors"
            disabled={deleteCustomer.isPending}
          >
            {deleteCustomer.isPending ? <LoadingCircle /> : 'Xóa'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default Delete;
